/**
 * @name MessageTemplates
 * @description Function for the MessageTemplates service
 * @param {type} $http Description
 * @param {type} ENDPOINT Description
 * @param {type} AlertMessages Description
 * @return {object} Returns the Shopmessage-templates service
 */
function MessageTemplates(
  $http,
  ENDPOINT,
  AlertMessages
) {
  MessageTemplates.get = get;
  MessageTemplates.update = update;

  /**
   * @name get
   * @description Function to get an array of message templates
   * @param {number} id The ID of the message templates
   * @return {object} Returns a message templates object
   */
  function get(id) {
    return $http.get(ENDPOINT.server + 'message-templates/api/v1.1/' + id + '/')
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Function to update message templates
   * @param {object} messageTemplates The message templates to update
   * @return {object} Returns the udpated message templates object
   */
  function update(messageTemplates) {
    return $http.put(ENDPOINT.server + 'message-templates/api/v1.1/' +
    messageTemplates.id + '/', messageTemplates)
    .then(function(response) {
      AlertMessages.add({
        msg: 'Your message templates have been saved.',
        type: 'success'
      });
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return MessageTemplates;
}

angular
  .module('inkfinder')
  .factory('MessageTemplates', MessageTemplates);



// WEBPACK FOOTER //
// ./components/message-templates/message-templates.service.js